import { FormInstance } from 'antd'
import FormValues from '../types/form-values'
import { StrapiCreate } from '../../../../../../../../types/strapi/strapi'
import StampOrder from '../../../../../../../../types/api/stamp-order'

export default function extractCreateStampOrderMutationArg(
    form: FormInstance<FormValues>
    // existingStampOrder?: StampOrder
): StrapiCreate<StampOrder> {
    const data: FormValues = form.getFieldsValue(true)
    // const number = data.number ?? existingStampOrder?.number

    return {
        data: {
            // ...(number != null && number !== '' ? { number } : {}),
            stamp: { set: [data.stamp] },
            quantity: data.quantity,
            estimatedDate: data.estimatedDate!.toISOString(),
            comment: data.comment,
            endDate: data.endDate?.toISOString(),
            orderStatus: data.orderStatus,
            initiator: data.initiator ? { set: [data.initiator] } : undefined,
            price: data.price,
        },
    } as StrapiCreate<StampOrder>
}
